import { styled } from '@mui/material/styles';
import { Button } from '@openx/components-core/lib/Button/Button.tsx';

export const StyledBackButton = styled(Button)`
  width: 121px;
`;
